/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupplierOrder } from '../../models/supplier-order';
import { UpdateSupplierOrderDto } from '../../models/update-supplier-order-dto';

export interface UpdateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params {
  supplierId: number;
  id: number;
      body: UpdateSupplierOrderDto
}

export function updateOneBaseMgmtSupplierOrderControllerSupplierOrder(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtSupplierOrderControllerSupplierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierOrder>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH, 'patch');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupplierOrder>;
    })
  );
}

updateOneBaseMgmtSupplierOrderControllerSupplierOrder.PATH = '/api/mgmt/supplier/{supplierId}/orders/{id}';
